import { useEffect } from 'react';

import { sendGaView } from 'methods/ga';
import { useAuth } from 'providers/Auth';
import { useParams } from 'react-router';

export default function WithTracker({ children, ga, paramkey = '', formatter, ...props }) {
    const { auth } = useAuth();
    const lineId = auth.userId;
    const params = useParams();
    const paramValue = paramkey ? params[paramkey] : '';
    const gaName = formatter ? formatter(ga, paramValue) : ga;

    useEffect(() => {
        if (lineId && gaName) sendGaView(lineId, gaName);
    }, [lineId, gaName]);

    return <>{children}</>;
}
